<app-spinner *ngIf="loading"></app-spinner>

<div class="top">
  <div class="filters" *ngIf="!loading">
    <button
      md-raised-button
      [color]="translated === null ? 'primary' : ''"
      (click)="setTranslated(null)"
    >
      All
    </button>
    <button
      md-raised-button
      [color]="translated === true ? 'primary' : ''"
      (click)="setTranslated(true)"
    >
      Translated
    </button>
    <button
      md-raised-button
      [color]="translated === false ? 'primary' : ''"
      (click)="setTranslated(false)"
    >
      Not translated
    </button>
    <span class="icon-gt-all">
      <md-icon
        *ngIf="editMode"
        class="cursor-pointer gtranslate"
        mdTooltip="Translate all non translated with Google Translate"
        (click)="googleTranslateAll()"
      >
        g_translate
      </md-icon>
    </span>
  </div>
  <form (submit)="searchTerm()" *ngIf="!loading">
    <md-form-field>
      <input
        name="term"
        type="text"
        mdInput
        [(ngModel)]="term"
        placeholder="Search term"
      />
    </md-form-field>
    <button md-raised-button type="submit" color="primary">
      <md-icon>search</md-icon>
      Search
    </button>
    <button md-raised-button type="button" (click)="searchClear()">
      <md-icon>clear</md-icon>
      Clear
    </button>
  </form>
</div>

<ngx-datatable
  #table
  *ngIf="!loading && translations !== null"
  style="height: 75vh; width: 95%"
  class="material"
  [rows]="translations"
  [columnMode]="'force'"
  [headerHeight]="50"
  [scrollbarV]="true"
  [footerHeight]="0"
  [rowHeight]="50"
  [externalSorting]="true"
  [reorderable]="false"
  [rowClass]="getRowClass"
  (sort)="onSort($event)"
  [loadingIndicator]="loadingIndicator"
>
  <ngx-datatable-column name="Last update" prop="lastUpdated" [width]="40">
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <span
        md-tooltip="{{ row.updatedByUser }}"
        mdTooltipPosition="right"
        *ngIf="row.lastUpdated"
        >{{ row.lastUpdated.value }}</span
      >
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Id" prop="id" [width]="10">
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <md-icon
        class="icon-lock-referential"
        *ngIf="row.lockStatus"
        tooltip="Locked in Chapca"
        >lock</md-icon
      >
      <md-icon class="icon-lock-referential" *ngIf="!row.lockStatus"
        >lock_open</md-icon
      >
      <span>{{ row.elementExternalId }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column name="Key" prop="name.value" [width]="100">
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <md-icon
        *ngIf="editMode"
        class="cursor-pointer gtranslate"
        (click)="googleTranslate(value, rowIndex)"
        mdTooltip="Translate with Google Translate"
      >
        g_translate
      </md-icon>
      {{ value }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column
    name="Short (25)"
    prop="shortName"
    cellClass="text-cell"
    [width]="100"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <div
        class="value-display"
        [ngClass]="{ edition: editMode }"
        [title]="editMode ? 'Click to edit' : ''"
        (click)="editRow(rowIndex, 'shortName')"
        *ngIf="!editing[rowIndex + '-shortName']"
      >
        <button
          *ngIf="value.modified"
          (click)="resetValue(rowIndex, 'shortName', $event)"
          md-icon-button
          color="primary"
          mdTooltip="Reset the value"
          title="Revert"
        >
          <md-icon>history</md-icon>
        </button>
        <span
          [ngClass]="{ modified: value.modified }"
          *ngIf="value.value !== undefined"
          >{{ value.value }}</span
        >
        <span
          *ngIf="
            (value.value === undefined || value.value === null) && editMode
          "
          class="edit"
          >CLICK TO EDIT</span
        >
      </div>
      <md-form-field *ngIf="editing[rowIndex + '-shortName']">
        <input
          title="ShortName"
          appFocus="true"
          data-row-index="{rowIndex}"
          mdInput
          maxlength="25"
          (blur)="onBlur($event, 'shortName', rowIndex)"
          type="text"
          [value]="value.value | undefinedToString"
          (keyup)="onKeyUp($event, 'shortName', rowIndex)"
        />
      </md-form-field>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column
    name="Long (100)"
    prop="longName"
    cellClass="text-cell"
    [width]="100"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <div
        class="value-display"
        [ngClass]="{ edition: editMode }"
        [title]="editMode ? 'Click to edit' : ''"
        (click)="editRow(rowIndex, 'longName')"
        *ngIf="!editing[rowIndex + '-longName']"
      >
        <button
          *ngIf="value.modified"
          (click)="resetValue(rowIndex, 'longName', $event)"
          md-icon-button
          color="primary"
          mdTooltip="Reset the value"
          title="Revert"
        >
          <md-icon>history</md-icon>
        </button>
        <span
          [ngClass]="{ modified: value.modified }"
          *ngIf="value.value !== undefined"
          >{{ value.value }}</span
        >
        <span
          *ngIf="
            (value.value === undefined || value.value === null) && editMode
          "
          class="edit"
          >CLICK TO EDIT</span
        >
      </div>
      <md-form-field *ngIf="editing[rowIndex + '-longName']">
        <input
          title="LongName"
          appFocus="true"
          data-row-index="{rowIndex}"
          mdInput
          maxlength="100"
          (blur)="onBlur($event, 'longName', rowIndex)"
          type="text"
          [value]="value.value | undefinedToString"
          (keyup)="onKeyUp($event, 'longName', rowIndex)"
        />
      </md-form-field>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    name="Pictures"
    cellClass="picture-cell"
    *ngIf="translationType && translationType.id === '2'"
    [width]="180"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <md-chip-list class="cursor-pointer">
        <md-chip
          *ngFor="let picture of row.pictures"
          (click)="editPicture(row, picture.pictureFormatName)"
        >
          {{ picture.pictureFormatName }}</md-chip
        >
      </md-chip-list>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    name="Pictogram"
    cellClass="picture-cell"
    *ngIf="
      (translationType && translationType.id === '2') ||
      translationType.id === '4'
    "
    [width]="180"
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <md-chip-list class="cursor-pointer">
        <md-chip (click)="editPicture(row, row.pictogram.pictureFormatName)"
          >{{ row.pictogram.pictureFormatName }}
        </md-chip>
      </md-chip-list>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column
    name=""
    [sortable]="false"
    [width]="1"
    *ngIf="
      translationType && translationType.id >= 2 && translationType.id <= 8
    "
  >
    <ng-template
      ngx-datatable-cell-template
      let-rowIndex="rowIndex"
      let-value="value"
      let-row="row"
    >
      <span
        tooltip-direction="left"
        tooltip-position="before"
        [tooltip]="row.tooltipContent"
        (mouseenter)="getTooltip(row);"
      >
        <md-icon class="link" (click)="seeClassifications(row)">
          help_outline
        </md-icon>
      </span>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>

<button
  *ngIf="!loading && editMode"
  md-raised-button
  color="accent"
  class="save"
  [disabled]="getNumberOfTranslationModified() === 0"
  (click)="saveTranslations()"
>
  <md-icon>save</md-icon>
  Save
  <span class="badge" *ngIf="getNumberOfTranslationModified() > 0">{{
    getNumberOfTranslationModified()
  }}</span>
</button>



// WEBPACK FOOTER //
// ./src/app/pages/translate/translations-list/translations-list.component.html